import React from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import NavigationBar from './components/NavigationBar';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <LandingPage />
      <NavigationBar />
      <About />
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;


